module.exports = __webpack_public_path__ + "img/eyein-partner-aruba.9b3fd494.webp";